import http from '@/library/http'

export function thisSession () {

  http.delete('logout/', {  withCredentials: true }).then((res) => {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh')
    location.href = '/login'
  })
}

export function allSessions () {
  http.delete('logout-all-sessions/', { withCredentials: true }).then((res) => {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh')
    location.href = '/login'
  })
}

export function thisSessionNoRedirect (callBack) {
  http.delete('logout/', { withCredentials: true }).then(
    (res) => {
      callBack()
    },
    (error) => {
      console.error(error)
      callBack()
    }
  )
}
